'use strict';
var base = require('./base');
const Modal = require('../modalUtilities');
var accessFocus = require('../accessibilityFocus');
var openFromBuyButton = false;
const footerElement = document.getElementsByTagName('footer')[0];
const viewportHeight = document.documentElement.clientHeight;
const navigationCountry = $('.page').attr('data-navigation-country');

if (navigationCountry === 'CN') {
    var TencentCaptcha = require('../common/tencentCaptcha');
}

var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

var observer = new MutationObserver(function(mutations, observer) {
    for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].target.className.toString().includes('helpButtonEnabled')) {
            if (window.isMobile) {
                var stickyHeight = $('.cc-sticky-add-to-cart').height();
                $('.helpButton, #embeddedMessagingConversationButton').css({
                    bottom: $(document).find('.cc-pdp').length > 0 ? '192px' : stickyHeight + 24,
                    right: '16px'
                });
                if ($('.cc-pd.cc-pd-cta-anchored').length > 0) {
                    $('.helpButton, #embeddedMessagingConversationButton').css({
                        bottom: '60px'
                    });
                }
            }
        }
    }
});
observer.observe(document, {
    subtree: true,
    attributes: true
});

const manageApplePayButtonApperance = (response) => {
    if (response.product.readyToOrder) {
        var applePayButton = $('.js-apple-pay-btn', response.$productContainer);
        if (applePayButton.length !== 0) {
            applePayButton.attr('sku', response.product.id);
        }

        if ($('body').is('.cc-safari')) {
            $('.js-fake-apple-pay').addClass('hidden');
            $('.js-apple-pay').removeClass('hidden').css('display','block');
        }
    } else {
        $('.js-fake-apple-pay').removeClass('hidden');
        $('.js-apple-pay').addClass('hidden').css('display', '');
    }
};

function fixLayoutForModalOpen() {
    liveChatDisable();
    $('.cc-pdp__info').css('z-index', '10');
}

function setButtonAttribute() {
    $('.selectpicker').selectpicker();
    $('.selectpicker').each(function() {
        $(this).css({
            display: 'none'
        });
        var label;
        // set button id for label
        if (this.labels.length > 0) {
            label = this.labels[0].innerText;
        } else {
            label = $(this).closest('.cc-form-group').find('.cc-label').html();
        }
        var $button = $(this).siblings('button');
        // var selectID = $(this).attr('id') + '_btn';
        // var labelID = $(this).attr('id') + '_lbl';
        // $(this).attr('aria-hidden', 'true');
        // $button.attr('id', selectID);
        $button.attr('aria-label', label);
        // $button.attr('aria-labelledby', selectID + ' ' + labelID);
        $(this).selectpicker('refresh');
        // fix voice over
        $(this).parent().find('.dropdown-toggle').removeAttr('role');
    });
}

function fixLayoutForModalOpenSize() {
    $('.cc-pdp__info').css('z-index', '10');
    liveChatDisable();
}

function fixLayoutForModalClose() {
    $('.cc-pdp__info').css('z-index', '3');
    $('.js-size-sticky').removeClass('cc-open');
    var loggedCustomerEmail = $('.js-requestsize-email').data('islogged');
    var islogged = (loggedCustomerEmail !== null && loggedCustomerEmail !== 'undefined');
    if (!islogged) {
        clearForm($('.js-form-control-requestsize'));
    }
    uploadFormRequestSize();
    liveChatEnable();
}

function uploadFormRequestSize() {
    $('.js-form-control-requestsize').fadeIn();
    $('.js-success-page-requestSize').fadeOut();
}

function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};
function liveChatDisable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
}

function liveChatPositionMove(top) {
    $('.helpButton, #embeddedMessagingConversationButton').each(function() {
        var topValue = top - $(this).height() - 15;
        var upperLimit = 100;
        $(this).css('top', topValue + 'px');
        if (topValue < upperLimit) {
            liveChatDisable();
        }
    });
}

function liveChatElement() {
    return $('.helpButton, #embeddedMessagingConversationButton').eq(0);
}

function liveChatPositionReset() {
    $('.helpButton, #embeddedMessagingConversationButton').each(function() {
        if (this.style.top) {
            $(this).css('top', '');

            if ($(this).is(':hidden')) {
                liveChatEnable();
            }
        }
    });
}

const closeModal = (element) => {
    const modalTarget = element.dataset.target;
    $(modalTarget).removeClass('cc-open').off('click');
    $(element).removeClass('cc-pdp-background-overlay').removeClass('cc-open');
    liveChatEnable();
};

const closeSizeChartModal = () => {
    // $('#size-chart-overlay').fadeOut();
    if (window.isMobile) {
        $('.cc-pdp__info').css('z-index', '3');
        $('.js-size-sticky').removeClass('cc-open');
        liveChatEnable();
    } else {
        var sticky = $('#js-open-from-sticky').val();
        if (sticky === 'true') {
            $('#size-modal-sticky').toggleClass('cc-open');
            $('.cc-pdp__info').css('z-index', '3');
        } else {
            $('body').addClass('cc-blocked');
        }
    }
    var loggedCustomerEmail = $('.js-requestsize-email').data('islogged');
    var islogged = (loggedCustomerEmail !== null && loggedCustomerEmail !== 'undefined');
    if (!islogged) {
        clearForm($('.js-form-control-requestsize'));
    }
    uploadFormRequestSize();
};
const openSizeChartModal = () => {
    // $('#size-chart-overlay').show();
    if (window.isMobile) {
        var mod = $('#size-chart-overlay-mobile').find('.cc-size-guide-standard.cc-size-guide-component');
        var headerHeigth = 81;
        var totHeigth = headerHeigth;
        if ($('.cc-shipment-banner').length > 0) {
            var bannerParent = $('.cc-shipment-banner').parent('div');
            var bannerHeigth = bannerParent.height();
            totHeigth += bannerHeigth;
        }
        mod.css('padding-top', totHeigth + 'px');
    } else {
        var sticky = $('#js-open-from-sticky').val();
        if (sticky === 'true') {
            $('#size-modal-sticky').toggleClass('cc-open');
        }
    }
    $('.cc-pdp__info').css('z-index', '10');

    // analytics
    $(document).trigger('analytics:dataLayerPushObj', {
        event: 'sizeChart',
        eventCategory: 'Size Chart',
        eventAction: 'open'
    });
};

function clearForm(form) {
    $(form).find('.cc-input.cc-error').removeClass('cc-error');
    $(form).find('.cc-feedback-message').children('.cc-text-message').text('');
    $(form).find('.cc-input.js-requestsize-firstName').val('');
    $(form).find('.cc-input.js-requestsize-lastName').val('');
    $(form).find('.cc-input.js-requestsize-email').val('');
    $('.js-requestsize-title').selectpicker('val', '');

    $('.alert', form).remove();
};

function updateSizeListLook () {
    var sku = $(document).find('.js-product-single-look').data('sku');
    var color = $(document).find('.js-product-single-look').data('color');
    var url = $('.js-selectSize .js-sizeSelector-url').data('getsizeurl');
    if (!$('.js-upload-size').hasClass('js-upload-compleated')) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                sku: sku,
                color: color
            },
            success: function (data) {
                for (var i = 0; i < data.checkSize.length; i++) {
                    var el = data.checkSize[i];
                    var $size = $(document).find('.js-checkSize-' + el.value);
                    var $RequestSize = $(document).find('.js-checkRequestSize-' + el.value);
                    if (el.selectable) {
                        $size.removeClass('col-6').removeClass('col-md-8').addClass('col-12');
                        $size.removeClass('cc-request-size');
                        $size.removeAttr('disabled');
                        $size.parent().removeClass('cc-request-size');
                        if (el.isOnlyOneLeft) {
                            $size.find('.js-limited-availability').removeClass('hidden');
                        }
                        $RequestSize.addClass('hidden');
                        $RequestSize.parent().addClass('hidden');
                    } else if (!el.selectable) {
                        $size.attr('disabled');
                        $size.addClass('col-6').addClass('col-md-8').removeClass('col-12');
                        $size.addClass('cc-request-size');
                        $size.parent().addClass('cc-request-size');
                        $size.find('.js-limited-availability').addClass('hidden');
                        if (!el.hideNotifyMeProduct) {
                            $RequestSize.removeClass('hidden');
                            $RequestSize.parent().removeClass('hidden');
                        }
                    } else if ($size.hasClass('col-12') && el.selectable) {
                        el.isOnlyOneLeft ? $size.find('.js-limited-availability').removeClass('hidden') : $size.find('.js-limited-availability').addClass('hidden');
                    }
                }
                $.spinner().stop();
            }
        });
    }
    $(document).find('.cc-size-list .cc-size-container').removeClass('cc-active');
    $(document).find('.cc-size-list button.cc-active').parent().addClass('cc-active');
};

function updateSizeList () {
    var sku = $('.product-detail').data('pid');
    var color = $('.js-color-choice.cc-active').data('attr-value');
    var url = $('.js-selectSize .js-sizeSelector-url').data('getsizeurl');
    if (!$('.js-upload-size').hasClass('js-upload-compleated')) {
        $.spinner().start();
        $.ajax({
            url: url,
            method: 'GET',
            data: {
                sku: sku,
                color: color
            },
            success: function (data) {
                for (var i = 0; i < data.checkSize.length; i++) {
                    var el = data.checkSize[i];
                    var $size = $('.js-checkSize-' + el.value);
                    var $RequestSize = $('.js-checkRequestSize-' + el.value);
                    if (el.selectable) {
                        $size.removeClass('col-6').removeClass('col-md-8').addClass('col-12');
                        $size.removeClass('cc-request-size');
                        $size.removeAttr('disabled');
                        $size.parent().removeClass('cc-request-size');
                        if (el.isOnlyOneLeft) {
                            $size.find('.js-limited-availability').removeClass('hidden');
                        }
                        $RequestSize.addClass('hidden');
                        $RequestSize.parent().addClass('hidden');
                    } else if (!el.selectable) {
                        $size.attr('disabled');
                        $size.addClass('col-6').addClass('col-md-8').removeClass('col-12');
                        $size.addClass('cc-request-size');
                        $size.parent().addClass('cc-request-size');
                        $size.find('.js-limited-availability').addClass('hidden');
                        if (!el.hideNotifyMeProduct) {
                            $RequestSize.removeClass('hidden');
                            $RequestSize.parent().removeClass('hidden');
                        }
                    } else if ($size.hasClass('col-12') && el.selectable) {
                        el.isOnlyOneLeft ? $size.find('.js-limited-availability').removeClass('hidden') : $size.find('.js-limited-availability').addClass('hidden');
                    }
                }
                $.spinner().stop();
            }
        });
    }
    $('.cc-size-list .cc-size-container').removeClass('cc-active');
    $('.cc-size-list button.cc-active').parent().addClass('cc-active');
};

function autoSelectForOneSize() {
    // automatically preselect size if product has only one size
    var numberofsizes = $('.js-size-container').data('numberofsizes');
    if (numberofsizes && parseInt(numberofsizes) === 1
        && $('.js-size-container') && $('.js-size-container').children() && $('.js-size-container').children().first()) {
        if ($('.js-size-container').children().first().is(':disabled')) {
            var sizeCode = $('.js-size-container').children().first().data('attr-value');
            $('#js-selected-size-to-find').val(sizeCode);
        } else {
            $('.js-size-container').children().first().trigger('click');
        }
    }
};

/* PDP Reccomendations Slider */
function recommendationSlider () {
    var arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev');
    var arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext');
    var arrowNext = $('.cc-product-list.cc-slider').data('arrowdx');
    var arrowPrev = $('.cc-product-list.cc-slider').data('arrowsx');
    if ($('.cc-product-list.cc-slider').length > 0) {
        if ($('.cc-product-list.cc-slider.slick-slide').length === 0) {
            $('.cc-product-list.cc-slider').each(function () {
                var slidesContainer = $(this);
                var slidesToShow = slidesContainer.data('items-row');

                slidesContainer.slick({
                    accessibility: false,
                    infinite: false,
                    autoplay: false,
                    focusOnSelect: false,
                    centerMode: false,
                    autoplaySpeed: 3000,
                    speed: 500,
                    slidesToScroll: 1,
                    slidesToShow: slidesToShow,
                    variableWidth: false,
                    dots: false,
                    dotsClass: 'slick-dots-line',
                    appendDots: $('.js-product-list-slick-dots'),
                    arrow: true,
                    prevArrow: '<button class="cc-slider-prev" aria-label="' + arialabelPrev + '"><svg class="cc-icon" aria-hidden="true" focusable="false"><use xlink:href="' + arrowPrev + '"></use></svg></button>',
                    nextArrow: '<button class="cc-slider-next" aria-label="' + arialabelNext + '"><svg class="cc-icon" aria-hidden="true" focusable="false"><use xlink:href="' + arrowNext + '"></use></svg></button>',
                    responsive: [
                        {
                            breakpoint: 1439.98,
                            settings: {
                                slidesToShow: 3,
                                dots: true,
                                arrow: false
                            }
                        },
                        {
                            breakpoint: 767.98,
                            settings: {
                                slidesToShow: 1,
                                dots: false,
                                arrow: true
                            }
                        }
                    ]
                });
            });
        }
    }
};

// da chiamare dopo il caricamento
function removeWishlistinRecommendation () {
    $('.cc-product-recommendations .cc-product-tile button.js-add-to-wishlist').remove();
}


// show success messagge for size requests
function uploadSuccesPage($selector, data) {
    $selector.empty().html(data.succesPageHtml);
};

module.exports = {
    updatePrice: function () {
        var pid = $('.product-detail.cc-pdp').attr('data-pid');
        $(document).trigger('product:updatePrices', [pid]);
    },
    loadVideo: function () {
        let $videoContainer = $('.js-video-container');
        if ($videoContainer.length === 0) {
            return;
        }

        let url = $videoContainer.data('video-url');
        $.ajax({
            url: url,
            success: function (data) {
                $('.js-video-iframe').attr('src', data.videoURL);
            }
        });
    },
    zoomElement: function () {
        var zoomCounter = 0;
        $('body').on('click', '.js-zoom', function (e) {
            let imageToZoom = e.currentTarget;
            let fullResolution = imageToZoom.src;
            var sixeClass = window.width < 768 ? 'js-max' : 'js-min';
            let fullResolutionSrcSet = $(imageToZoom).closest('.cc-content-image').find('picture source.' + sixeClass)[0].srcset;
            let $zoomedImage = $('.js-zoom-modal img');
            fullResolutionSrcSet = fullResolutionSrcSet.replace(/c_scale,w_\d+\//g, ''); // get rid of scale to show better resolution
            $.spinner().start();
            $('.js-zoom-modal').removeClass('hidden').removeClass('cc-loaded');
            $zoomedImage.addClass('hidden');
            $zoomedImage.attr('src', fullResolution);
            $zoomedImage.attr('srcset', fullResolutionSrcSet);

            if (zoomCounter > 0) {
                $('.js-zoom-modal').removeClass('cc-loading').addClass('cc-loaded');
                $zoomedImage.removeClass('hidden');
                $('body').addClass('cc-blocked');
            } else {
                zoomCounter++;
                $zoomedImage.on('load', (e) => {
                    $('.js-zoom-modal').addClass('cc-loaded');
                    $.spinner().stop();
                    $zoomedImage.removeClass('hidden');
                    var outerContent = $('.js-zoom-modal');
                    var innerContent = $('.js-zoom-modal img');
                    $('body').addClass('cc-blocked');
                    outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
                    outerContent.scrollTop((innerContent.height() - outerContent.height()) / 2);
                });
            }
        });

        $('body').on('click', '.js-zoom-modal img', function (e) {
            $('.js-zoom-modal').addClass('hidden').removeClass('cc-loaded');
            $('body').removeClass('cc-blocked');
        });

        // Accessibility
        $('body').on('keypress', '.js-zoom', function (e) {
            if(e.key === "Enter") {
                let imageToZoom = e.currentTarget;
                let fullResolution = imageToZoom.src;
                var sixeClass = window.width < 768 ? 'js-max' : 'js-min';
                let fullResolutionSrcSet = $(imageToZoom).closest('.cc-content-image').find('picture source.' + sixeClass)[0].srcset;
                let $zoomedImage = $('.js-zoom-modal img');
                $.spinner().start();
                $('.js-zoom-modal').removeClass('hidden').removeClass('cc-loaded');
                $zoomedImage.addClass('hidden');
                $zoomedImage.attr('src', fullResolution);
                $zoomedImage.attr('srcset', fullResolutionSrcSet);
                if (zoomCounter > 0) {
                    $('.js-zoom-modal').removeClass('cc-loading').addClass('cc-loaded');
                    $zoomedImage.removeClass('hidden');
                    $('body').addClass('cc-blocked');
                } else {
                    zoomCounter++;
                    $zoomedImage.on('load', (e) => {
                        $('.js-zoom-modal').addClass('cc-loaded');
                        $.spinner().stop();
                        $zoomedImage.removeClass('hidden');
                        var outerContent = $('.js-zoom-modal');
                        var innerContent = $('.js-zoom-modal img');
                        $('body').addClass('cc-blocked');
                        outerContent.scrollLeft((innerContent.width() - outerContent.width()) / 2);
                        outerContent.scrollTop((innerContent.height() - outerContent.height()) / 2);
                    });
                }
            } else {
                $('.js-zoom-modal').addClass('hidden').removeClass('cc-loaded');
                $('body').removeClass('cc-blocked');
            }
        });

        $('body').on('focusout', '.js-zoom', function (e) {
            $('.js-zoom-modal').addClass('hidden').removeClass('cc-loaded');
            $('body').removeClass('cc-blocked');
        });
    },
    show3D: function () {
        $(document).on('click', '.js-show-product-3d', function() {
            var $wannaIframe = $('#wanna3dIframe');
            if (! $wannaIframe.attr('src')) {
                var isMobileOrTablet = window.isMobile || window.isTablet;
                var url = $wannaIframe.attr('data-src');
                url = url.replace('retrieve_viewmode', isMobileOrTablet ? 'mobile' : 'desktop');
                $wannaIframe.attr('src', url);
            }
            // show 3d modal
            $('.cc-pdp__3dView').removeClass('d-none');
            $('body').addClass('cc-blocked');

            // push history state
            var searchParams = new URLSearchParams(window.location.search);
            searchParams.set("view", "3dmodel");
            var newURL = `${window.location.pathname}?${searchParams.toString()}`;
            history.pushState(undefined, '', newURL);

            // hide modal on history popstate
            $(window).one('popstate', function() {
                $('.cc-pdp__3dView').addClass('d-none');
                $('body').removeClass('cc-blocked');
            });

            var id = $('.product-detail').data('pid');
            $('body').trigger('analytics:dataLayerPushObj', {
                event: 'custom_event',
                eventCategory: '3D Preview',
                eventAction: 'open',
                eventLabel: id,
                accessType: 'pdp'
            });
        });
    },
    addToCart: function () {
        $('body').on('click', 'button.add-to-cart', function (e, extra) {
            e.stopPropagation();
            if ($('.add-to-cart').data('disabled')) {
                let isInSticky = !!$(e.currentTarget).closest('.js-sticky').length || window.isMobile;
                openFromBuyButton = true;
                if (isInSticky) {
                    // Close all other modals opened sticky
                    $('.js-sticky-choice').each((_idx, el) => {
                        let $el = $(el);
                        $el.removeClass('cc-open');
                        $($el.data('target')).removeClass('cc-open');
                    });
                    // open size modal sticky
                    const modalTarget = $('.js-size-sticky').data('target');
                    $('.js-size-sticky').toggleClass('cc-open');
                    $(modalTarget).toggleClass('cc-open');

                    var pdpMobileExpanded = window.isMobile && $('.cc-pdp__info--top').length;
                    var modalOffsetTop = $(modalTarget).offset().top;
                    if (! pdpMobileExpanded) {
                        liveChatPositionMove(modalOffsetTop);
                    } else {
                        var $liveChat = liveChatElement();
                        if ($liveChat.length) {
                            var liveChatBottom = $liveChat[0].getBoundingClientRect().bottom;
                            var modalBottom = $(modalTarget)[0].getBoundingClientRect().bottom;
                            if (liveChatBottom < modalBottom) {
                                liveChatPositionMove(modalOffsetTop);
                            }
                        }
                    }
                    if (! window.isMobile) {
                        liveChatDisable();
                    }
                } else {
                    let modalTarget = $('.js-size-modal').eq(0).data('target');
                    let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpenSize, onClose: fixLayoutForModalClose });
                    modal.open();
                    $('body').one('product:afterAttributeSelect', () => {
                        modal.close();
                    });
                    $('.js-check-availability').one('click', () => { modal.close(); });
                    $('.js-close-requestSize').one('click', () => { modal.close(); });
                }
                if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                    updateSizeListLook();
                } else updateSizeList();

                var id = $('.product-detail').attr('data-skumaster');
                var color = $('.js-color-choice.cc-active').data('attr-value');

                // new analytics parameter: accessType
                if (extra && extra.accessType){
                    var accessType = extra.accessType;
                    $('#size-modal-sticky').data('accessType', accessType);
                } else {
                    if ($('body:not(.cc-mobile)').length) {
                        if ($(this).parents('.js-sticky-add-to-cart').length) {
                            var accessType = 'pdp-sticky-bottom';
                        } else {
                            var accessType = 'pdp';
                        }
                    } else if ($('.cc-pdp__info--top').length) {
                        var accessType = 'pdp-sticky-top-macro';
                    } else {
                        var accessType = 'pdp-sticky-bottom';
                    }
                    $('#size-modal-sticky').data('accessType', accessType);
                }
                var analyticsOwn = 'add to cart';
                $('#size-overlay').data('analyticsowner', analyticsOwn);
                $('body').trigger('analytics:dataLayerPushObj', {
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'open',
                    eventLabel: id + color,     // pid concatenation PDP
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
            } else {
                if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                    updateSizeListLook();
                } else updateSizeList();
                if (!$('.js-upload-size .cc-active .js-select-size').hasClass('cc-request-size')) {
                    if ($(e.currentTarget).hasClass('js-add-to-cart-sticky-look')) {
                        base.performAddToCartLook(this);
                    } else base.performAddToCart(this);
                } else {
                    let modalTarget = $('.js-size-modal').eq(0).data('target');
                    let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
                    modal.open();
                    $('body').one('product:afterAttributeSelect', () => {
                        modal.close();
                    });
                    $('.js-check-availability').one('click', () => { modal.close(); });
                    $('.js-close-requestSize').one('click', () => { modal.close(); });
                }
            }
        });
    },
    openSizeSelector: function () {
        const performOpenSizeSelector = (e) => {
            e.stopPropagation();
            let modalTarget = e.currentTarget.dataset.target;
            let modal = new Modal(modalTarget, { onShow: fixLayoutForModalOpenSize, onClose: fixLayoutForModalClose });

            updateSizeList();
            modal.open();
            $('body').one('product:afterAttributeSelect', () => {
                modal.close();
            });
            $('.js-check-availability').one('click', () => { modal.close(); });
            $('.js-close-requestSize').one('click', () => { modal.close(); });
        };
        // Open the size modal in PDP
        $('body').on('click', '.js-open-choice', (e, extra) => {
            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            performOpenSizeSelector(e);

            var colorModal = e.currentTarget.classList.contains('js-open-color-choice');

            if (!colorModal) {
                var sku = $(e.currentTarget).closest('.product-detail').attr('data-skumaster');
                let color = $('.js-color-choice.cc-active').data('attr-value');
                var analyticsOwn = $('#size-overlay').data('analyticsowner'); // paypal insert value before open modal
                if (!analyticsOwn) {
                    analyticsOwn = 'select size';
                    $('#size-overlay').data('analyticsowner', analyticsOwn);
                }
                // new analytics parameter: accessType
                if ($('body:not(.cc-mobile)').length) {
                    if ($(this).parents('.js-sticky-add-to-cart').length) {
                        var accessType = 'pdp-sticky-bottom';
                    } else {
                        var accessType = 'pdp';
                    }
                } else if ($('.cc-pdp__info--top').length) {
                    var accessType = 'pdp-sticky-top-macro';
                } else {
                    var accessType = 'pdp-sticky-bottom';
                }
                if (!$('#size-modal-sticky').data('accessType')) {
                    $('#size-modal-sticky').data('accessType', accessType);
                }
                if (extra || $('#size-modal-sticky').data('accessType')) {
                    accessType = extra? extra.accessType : $('#size-modal-sticky').data('accessType');
                }
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'open',
                    eventLabel: sku + color,    // pid concatenation PDP
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
            }
        });
        $('body').on('click', '.js-fake-apple-pay.js-desktop', (e) => {
            var id = $('.product-detail').attr('data-skumaster');
            var color = $('.js-color-choice.cc-active').data('attr-value');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'open',
                eventLabel: id + color,     // pid concatenation PDP
                buttonType: 'applepay'
            });
            $('#size-overlay').data('analyticsowner', 'applepay');
            performOpenSizeSelector(e);
        });
        $('body').on('click', '.js-fake-apple-pay.js-mobile', (e) => {
            var id = $('.product-detail').attr('data-skumaster');
            var color = $('.js-color-choice.cc-active').data('attr-value');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'open',
                eventLabel: id + color,     // pid concatenation PDP
                buttonType: 'applepay'
            });
            $('#size-overlay').data('analyticsowner', 'applepay');
            // open size modal sticky
            const modalTarget = $('.js-size-sticky').data('target');
            $('.js-size-sticky').toggleClass('cc-open');
            $(modalTarget).toggleClass('cc-open');
            e.stopPropagation();
        });
        $('.js-analytics-close-selectsize').on('click', function(e) {
            var id = $('.product-detail').attr('data-skumaster');
            var color = $('.js-color-choice.cc-active').data('attr-value');
            var analyticsOwn = $('#size-overlay').data('analyticsowner');
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'Size Selector',
                eventAction: 'close',
                eventLabel: id + color,     // pid concatenation PDP
                buttonType: analyticsOwn
            });
            $('#size-overlay').removeData('analyticsowner');
        });
    },
    openStickySelector: function () {
        // Open the size modal in PDP
        $('body').on('click', '.js-sticky-choice', function (e, extra) {

            // Change aria-expanded of button color on click
            var button = $(this).find('.cc-content-thumb-color-sticky');
            var currentAriaExpanded = button.attr('aria-expanded');
            var newAriaExpanded = (currentAriaExpanded === 'true') ? 'false' : 'true';
            button.attr('aria-expanded', newAriaExpanded);

            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            e.stopPropagation();
            let isCurrentModalOpen = $(e.currentTarget).hasClass('cc-open');
            if (! isCurrentModalOpen) {
                updateSizeList();
            }
            $('.js-sticky-choice').each((_idx, el) => {
                // Close all other modals opened
                let $el = $(el);
                $el.removeClass('cc-open');
                $($el.data('target')).removeClass('cc-open');
                liveChatEnable();
            });
            liveChatPositionReset();
            
            let isSizeBtn = $(e.currentTarget).hasClass('js-size-sticky');
            var sku = $(e.currentTarget).closest('.product-detail').attr('data-skumaster');
            let color = $('.js-color-choice.cc-active').data('attr-value');
            var analyticsOwn = $('#size-modal-sticky').data('analyticsowner') || $('#size-overlay').data('analyticsowner');
            // new analytics parameter: accessType
            if (extra && extra.accessType){
                var accessType = extra.accessType;
                $('#size-modal-sticky').data('accessType', accessType);
            } else if ($('#size-modal-sticky').data('accessType')){
                accessType = $('#size-modal-sticky').data('accessType');
            } else {
                if ($('body:not(.cc-mobile)').length) {
                    if ($(this).parents('.js-sticky-add-to-cart').length) {
                        var accessType = 'pdp-sticky-bottom';
                    } else {
                        var accessType = 'pdp';
                    }
                } else if ($('.cc-pdp__info--top').length) {
                    var accessType = 'pdp-sticky-top-macro';
                } else {
                    var accessType = 'pdp-sticky-bottom';
                }
                $('#size-modal-sticky').data('accessType', accessType);
            }

            if (!isCurrentModalOpen) {
                // If the modal was not open before, close it. If the modal was open before, it means
                // we are closing it, but we did it in the each loop
                let $modal = $(e.currentTarget).toggleClass('cc-open').data('target');
                $($modal).toggleClass('cc-open');

                var pdpMobileExpanded = window.isMobile && $('.cc-pdp__info--top').length;
                var modalOffsetTop = $($modal).offset().top;
                if (! pdpMobileExpanded) {
                    liveChatPositionMove(modalOffsetTop);
                } else {
                    var $liveChat = liveChatElement();
                    if ($liveChat.length) {
                        var liveChatBottom = $liveChat[0].getBoundingClientRect().bottom;
                        var modalBottom = $($modal)[0].getBoundingClientRect().bottom;
                        if (liveChatBottom < modalBottom) {
                            liveChatPositionMove(modalOffsetTop);
                        }
                    }
                }

                if (isSizeBtn) {
                    if (!analyticsOwn || e.originalEvent !== undefined) {
                        analyticsOwn = 'select size';
                        $('#size-modal-sticky').data('analyticsowner', analyticsOwn);
                    }
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Size Selector',
                        eventAction: 'open',
                        eventLabel: sku + color,    // pid concatenation PDP
                        buttonType: analyticsOwn,
                        accessType: accessType
                    });
                }
            } else if (isSizeBtn) {
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'close',
                    eventLabel: sku + color,    // pid concatenation PDP
                    buttonType: analyticsOwn,
                    accessType: accessType
                });
                $('#size-modal-sticky').removeData('analyticsowner');
                $('#size-overlay').removeData('analyticsowner');
                $('#size-modal-sticky').removeData('accessType');
            }
        });
    },
    openStickySelectorLook: function () {
        // Open the size modal in PDP
        $('body').on('click', '.js-sticky-choice-look', function (e) {
            openFromBuyButton = false;
            $('#4giftButtonSizeNotSelected').val('false');
            $('#payPalButtonSizeNotSelected').val('false');
            e.stopPropagation();
            updateSizeListLook();
            if ($('.product-detail .cc-content-colors-choice-sticky .cc-slider').length > 0) {
                if ($('.product-detail .cc-content-colors-choice-sticky .cc-slider .slick-slide').length === 0) {
                    $('.product-detail .cc-content-colors-choice-sticky .cc-slider').each(function () {
                        var slidesContainer = $(this);
                        slidesContainer.slick({
                            infinite: false,
                            autoplay: false,
                            focusOnSelect: true,
                            centerMode: false,
                            autoplaySpeed: 3000,
                            speed: 500,
                            slidesToScroll: 1,
                            slidesToShow: 5,
                            variableWidth: false,
                            dots: false,
                            arrow: true,
                            prevArrow: '<button class="cc-slider-prev"><div class="cc-svg cc-svg-slider-prev"><span> < </span></div></button>',
                            nextArrow: '<button class="cc-slider-next"><div class="cc-svg cc-svg-slider-next"><span> > </span></div></button>',
                            responsive: [
                                {
                                    breakpoint: 1199.98,
                                    settings: {
                                        slidesToShow: 12
                                    }
                                },
                                {
                                    breakpoint: 767.98,
                                    settings: {
                                        slidesToShow: 5
                                    }
                                }
                            ]
                        });
                    });
                }
            };
            let isCurrentModalOpen = $(e.currentTarget).hasClass('cc-open');
            $('.js-sticky-choice-look').each((_idx, el) => {
                // Close all other modals opened
                let $el = $(el);
                $el.removeClass('cc-open');
                $($el.data('target')).removeClass('cc-open');
                liveChatEnable();
            });
            let isSizeBtn = $(e.currentTarget).hasClass('js-size-sticky');
            var sku = $(e.currentTarget).closest('.js-product-single-look').attr('data-sku');
            var color = $(e.currentTarget).closest('.js-product-single-look').attr('data-color');
            if (!isCurrentModalOpen) {
                // If the modal was not open before, close it. If the modal was open before, it means
                // we are closing it, but we did it in the each loop
                let $modal = $(e.currentTarget).toggleClass('cc-open').data('target');
                $($modal).toggleClass('cc-open');
                if (isSizeBtn) {
                    var analyticsOwn = 'select size';
                    $('#size-modal-sticky').data('analyticsowner', analyticsOwn);
                    dataLayer.push({
                        event: 'custom_event',
                        eventCategory: 'Size Selector',
                        eventAction: 'open',
                        eventLabel: sku + color,    // pid concatenation PDP
                        buttonType: analyticsOwn
                    });
                }
            } else if (isSizeBtn) {
                var analyticsOwn = $('#size-modal-sticky').data('analyticsowner');
                dataLayer.push({
                    event: 'custom_event',
                    eventCategory: 'Size Selector',
                    eventAction: 'close',
                    eventLabel: sku + color,    // pid concatenation PDP
                    buttonType: analyticsOwn
                });
                $('#size-modal-sticky').removeData('analyticsowner');
            }
        });
    },
    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');
            if ($productContainer.length === 0) {
                $productContainer = $('.product-detail[data-pid="' + $('#idNumberSizeSelectedUrl').val() + '"]');
            }
            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);
            // update request size modal after select product variation
            $productContainer.find('.js-productVariation-update')
                .empty()
                .html(data.requestSizeHtml);
            $('.cc-select.js-requestsize-size').selectpicker();
            $('.cc-select.js-requestsize-title').selectpicker();

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },
    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            $('.product-detail').data('pid', response.data.product.id);
            $('.js-open-contact').data('sku', response.data.product.sku);
            var skuWColor = response.data.product.skuMaster;
            var colorAttr = response.data.product.variationAttributes[0].values;
            for (var i = 0; i < colorAttr.length; i++) {
                if (colorAttr[i].selected) {
                    skuWColor += colorAttr[i].id;
                }
            }
            $('.js-find-in-store-button').attr('data-sku', skuWColor);
            $('.js-open-choice').toArray().forEach(closeModal);
            $('.js-sticky-choice').toArray().forEach(closeModal);
            liveChatPositionReset();

            // Close open modals
            if (openFromBuyButton) {
                var $addToCartButton = $('.cc-pdp__add-to-cart .add-to-cart');
                base.performAddToCart($addToCartButton);
            }
            if ($('#4giftButtonSizeNotSelected').val() === 'true') {
                $('body').trigger('product:afterAttributeSelect4gift');
            }

            // trigger wishlist update
            $('body').trigger('wishlist:productVariantChanged', { newPDP: true });

            if ($('.js-recommendationTemplate').length) {
                var url = $('#urlRecommendations').val();
                var queryString = window.location.search;
                var queryPid = queryString == '' ? '?pid=' : '&pid=';
                var completeUrl = url + queryString + queryPid + skuWColor;

                $.ajax({
                    url: completeUrl,
                    method: 'GET',
                    success: function (data) {
                        if (data) {
                            $('.js-product-recommendations [id^="cq_recomm_slot"]').remove();
                            $('.js-recommendationTemplate').html(data).removeClass('d-none');
                            $('.js-product-recommendations').removeClass('d-none');
                            recommendationSlider();
                            removeWishlistinRecommendation();

                            document.querySelectorAll('iframe.lazyload').forEach(video => {
                                let endPoint = $(video).eq(0).attr('data-video-url');
                                if (!endPoint) {
                                    return;
                                }
                                if ($(video).hasClass('cloudinary')) {
                                    video.setAttribute('src', endPoint);
                                } else {
                                    $.ajax({
                                        url: endPoint,
                                        method: 'GET',
                                        success: function(data) {
                                            $(video).attr('src', data.videoURL);
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).data('disabled',
                (!response.product.readyToOrder || !response.product.available));
            manageApplePayButtonApperance(response);
        });
    },
    closeSizeChart: function () {
        $(document).on('click', '.js-close-size-chart', function () {
            var sizeChartOverlayId;
            var sizeOverlay;
            var openedFromSticky = $('#js-open-from-sticky').val();
            if (window.isMobile) {
                sizeChartOverlayId = '#size-chart-overlay-mobile';
                sizeOverlay = '#size-modal-sticky';
            } else {
                sizeChartOverlayId = '#size-chart-overlay';
                sizeOverlay = '#size-overlay';
            }

            if (!window.mobile) {
                var modal = new Modal(sizeOverlay, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                modal.close();
            } else {
                var modal = new Modal(sizeOverlay, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
                modal.open();
                $('.product-detail .cc-info-section').removeAttr('style');
            }
        });
    },
    initializeSize: function() {
        $(document).ready(function() {
            autoSelectForOneSize();
        });
    },
    addToCartAutomatic: function() {
        $(document).on('pdp:productDetailEventPushed', function () {
            var addToCartAutomatic = $('#addToCartAutomatic').val();
            if (addToCartAutomatic === 'true') {
                if (window.isMobile) {
                    if (!$($('button.add-to-cart')[1]).data('disabled')) {
                        $($('button.add-to-cart')[1]).attr('data-sticky', 'automatic');
                        $($('button.add-to-cart')[1]).click();
                    }
                } else {
                    if (!$($('button.add-to-cart')[0]).data('disabled')) {
                        $($('button.add-to-cart')[0]).attr('data-sticky', 'automatic');
                        $($('button.add-to-cart')[0]).click();
                    }
                }
            }
        });
    },
    positionStickyElement: function () {
        const closeAllOpenSubwindow = () => {
            var stickyTouched = $('.cc-pdp__stickymobile').data('touched');
            let $modals = $('.cc-sticky-add-to-cart, .cc-pdp__stickymobile').find('.js-sticky-choice').toArray();
            $modals.forEach((el) => {
                if (! $($(el).data('target')).not('#size-modal-sticky, #color-modal-sticky').length && !stickyTouched) {
                    $(el).removeClass('cc-open');
                    $($(el).data('target')).removeClass('cc-open');
                }
            });

            liveChatPositionReset();
        };
        let scrollTimer;
        $(document).on('scroll', function () {
            // Manage the fact that scroll events are extremely common: if another scroll event was registered less than 250
            // milliseconds before, we do not consider it
            if (scrollTimer) {
                clearTimeout(scrollTimer);
            }
            if ($('.js-sticky-add-to-cart').attr('data-recent-click')) {
                // prevent stickybar from instantly hiding when clicking on size or color buttons.
                return;
            }
            closeAllOpenSubwindow();
            let $sticky = $('.cc-sticky-add-to-cart').not('.js-sticky-add-to-cart-look');
            var visibleCheckElement = document.getElementsByClassName('visible-check');
            let isAddToCartVisible = false;
            if (visibleCheckElement.length > 0) {
                isAddToCartVisible = visibleCheckElement && visibleCheckElement[0].getBoundingClientRect().bottom > 0;
            }
            let isFooterVisible = document.getElementsByTagName('footer')[0].getBoundingClientRect().top < viewportHeight;
            let stickyCanAppear;
            let stickyIsOpen = $sticky.hasClass('cc-open');
            stickyCanAppear = !isAddToCartVisible && !isFooterVisible;
            var $liveChat = $('.helpButton, #embeddedMessagingConversationButton');
            if (stickyCanAppear && !stickyIsOpen) {
                scrollTimer = setTimeout(() => {                    
                    $sticky.addClass('cc-open').removeClass('cc-close').css('display', '');
                    var chatBottom = parseInt($liveChat.css('bottom'));
                    var stickyHeight = 50;
                    var stickyBottom = 40;
                    $liveChat.css('bottom', stickyHeight + stickyBottom + chatBottom + 'px');
    
                }, 250);
            }
            if (!stickyCanAppear && stickyIsOpen) {
                // Set aria-expanded to false on the btn color selection when sticky bar disappear
                $('.cc-content-thumb-color-sticky').attr('aria-expanded', 'false');
                $sticky.removeClass('cc-open').addClass('cc-close').css('display', 'none');                
                $liveChat.css('bottom', '');
            }
        });

        const $stickyOverlay = $('.cc-size-choice-overlay-sticky');
        const $stickyColor = $('.cc-content-colors-choice-sticky');

        $(document).click(e => {
            if (!$stickyOverlay.is(e.target)
                && $stickyOverlay.has(e.target).length === 0
                && !$stickyColor.is(e.target) &&
                $stickyColor.has(e.target).length === 0) {
                if ($('.js-sticky-choice').hasClass('cc-open')) {
                    liveChatEnable();
                }
                closeAllOpenSubwindow();
            }
        });
    },
    setIdForModalDialogattributes: function() {
        $(document).ready(function() {
            // set dialog id selectsticky
            var ariaDescribedBy = $('.cc-size-choice-overlay-sticky').attr('aria-describedby');
            var ariaLabelledby = $('.cc-size-choice-overlay-sticky').attr('aria-labelledby');
            $('.cc-size-choice-overlay-sticky .cc-head-title').attr('id', ariaLabelledby);
            $('.cc-size-choice-overlay-sticky .js-change-for-stiky').attr('id', ariaDescribedBy);
            // set dialog id whishlistMesage
            var $wishListMessage = $('.cc-pdp__content-attributes .cc-add-to-wishlist-message');
            var ariaDescribedByWish = $wishListMessage.attr('aria-describedby');
            var newAriaDescribedByWish = ariaDescribedByWish + '-Mobile';
            var ariaLabelledbyWish = $wishListMessage.attr('aria-labelledby');
            var newAriaLabelledbyWish = ariaLabelledbyWish + '-Mobile';
            $('.cc-pdp__content-attributes .cc-add-to-wishlist-message .cc-prod-title').attr('id', newAriaLabelledbyWish);
            $('.cc-pdp__content-attributes .cc-add-to-wishlist-message .js-wish-changeId-forMobile').attr('id', newAriaDescribedByWish);
            $wishListMessage.attr('aria-describedby', newAriaDescribedByWish);
            $wishListMessage.attr('aria-labelledby', newAriaLabelledbyWish);
            // set id for button selectsize stiky
            $('.cc-size-choice-overlay-sticky .js-open-size-chart').attr('id', 'size-chart-stiky');
            $('.cc-size-choice-overlay-sticky .js-open-helpWhitSize').attr('id', 'size-help-sticky');
        });
    },
    setNumberPageCarouselReccomandation: function() {
        $('.cc-product-recommendations .cc-slider').on('setPosition', function(event, slick) {
            var slideTosho = $('.cc-product-recommendations .cc-slider').data('items-row');
            if ($(window).width() < 1439.98) slideTosho = 3;
            if ($(window).width() < 767.98) slideTosho = 1;
            var currentSlide = slick.currentSlide + 1;
            var totalSlide = slick.slideCount - (slideTosho - 1);
            var arialabelPrev;
            if (currentSlide <= totalSlide && (currentSlide - 1) > 0) {
                arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev').replace('{0}', currentSlide - 1).replace('{1}', totalSlide);
            } else {
                arialabelPrev = $('.cc-product-list.cc-slider').data('arialabelprev').replace('{0}', currentSlide).replace('{1}', totalSlide);
            }
            var arialabelNext;
            if ((currentSlide + 1) <= totalSlide) {
                arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext').replace('{0}', currentSlide + 1).replace('{1}', totalSlide);
            } else {
                arialabelNext = $('.cc-product-list.cc-slider').data('arialabelnext').replace('{0}', currentSlide).replace('{1}', totalSlide);
            }
            $('.cc-product-recommendations .cc-slider-prev').attr('aria-label', arialabelPrev);
            $('.cc-product-recommendations .cc-slider-next').attr('aria-label', arialabelNext);
            // set tabindex -1 if product isn't show, and 0 if is show
            $('.slick-slide').each(function() {
                $(this).attr('aria-hidden') === 'true' ? $(this).attr('tabindex', '-1') : $(this).attr('tabindex', '0');
            });
        });
    },
    loadRecommendations: function () {
        $(document).ready(function () {
            if ($('.js-recommendationTemplate:not(.js-do-not-load)').length) {
                if ($('.cc-product-detail--shop-look').length === 0) {
                    var url = $('#urlRecommendations').val();
                    var pid = $('.product-detail').data('pid');
                    var queryString = window.location.search;
                    var queryPid = queryString == '' ? '?pid=' : '&pid=';
                    var completeUrl = url + queryString + queryPid + pid;
                    $.ajax({
                        url: completeUrl,
                        method: 'GET',
                        success: function (data) {
                            if (data) {
                                $('.js-recommendationTemplate').html(data);
                                $('.js-product-recommendations').removeClass('d-none');
                                recommendationSlider();
                                removeWishlistinRecommendation();
                                // handle iframes with no lazysizes library
                                document.querySelectorAll('iframe.lazyload').forEach(video => {
                                    let endPoint = $(video).eq(0).attr('data-video-url');
                                    if (!endPoint) {
                                        return;
                                    }
                                    if ($(video).hasClass('cloudinary')) {
                                        video.setAttribute('src', endPoint);
                                    } else {
                                        $.ajax({
                                            url: endPoint,
                                            method: 'GET',
                                            success: function(data) {
                                                $(video).attr('src', data.videoURL);
                                            }
                                        });
                                    }
                                });
                            }
                        }
                    });
                }
            }
        });
    },
    openRequestSizeFromPlp: function () {
        $(document).ready(function () {
            var size = $('.js-open-requestsize-from-plp').data('requestsize');
            if (size !== null && (size !== undefined) && (size !== 'undefined')) {
                $('.cc-size-choice-overlay-sticky').find('.js-check-availability').each(function() {
                    if ($(this).data('size') === size) {
                        $(this).click();
                        return false;
                    }
                });
            }
        });
    },
    openRequestSize: function () {
        $(document).on('click', '.js-check-availability', function (e) {
            var urlGetParameter = $(this).data('parameter');
            var strokeClose = $(e.currentTarget).data('strokeclose');
            var arrow = $(e.currentTarget).data('arrowback');
            var size = $(e.currentTarget).data('size');
            var ecomSize = this.dataset.sizehtml;
            var sku = $('.product-detail').data('pid');
            var color = $('.js-color-choice.cc-active').data('attr-value');
            const ajaxData = {
                size: size,
                ecomSize: ecomSize,
                sku: sku,
                color: color
            }
            var target = this.dataset.target;
            var overlay;
            if (window.isMobile) {
                target = target + '-mob';
                overlay = '#js-requestSize-product-overlay-mob';
            } else {
                target = target + '-desk';
                overlay = '#js-requestSize-product-overlay-desk';
            }
            let m = new Modal(target, { onShow: fixLayoutForModalOpen, onClose: fixLayoutForModalClose });
            var $stickyModal = $(this).closest('.cc-size-choice-overlay-sticky');
            if ($stickyModal.length > 0) {
                $stickyModal.removeClass('cc-open');
                $stickyModal.siblings('.cc-size-choice-button-sticky.js-size-sticky.js-sticky-choice').removeClass('cc-open');
            }
            
            if (navigationCountry === 'CN' && !TencentCaptcha.isAlreadyLoaded()) {
                ajaxData['loadTencentCaptcha'] = true;
            }
            $.spinner().start();
            $.ajax({
                url: urlGetParameter,
                method: 'POST',
                data: ajaxData,
                success: function (data) {
                    $(overlay).html(data);
                    $.spinner().stop();
                    setButtonAttribute();
                    m.open();
                    if (window.isMobile) {
                        $('.cc-requestsize-only-mobile .js-change-icon').attr('xlink:href', strokeClose);
                    }
                    $('#request-size-overlay-desk .js-back-selectsize').one('click', () => {
                        m.close();
                        $('.js-back-selectsize').children().attr('xlink:href', arrow);
                    });
                    $('#request-size-overlay-mob .js-back-selectsize').one('click', () => {
                        $(m.modal).removeClass('cc-open');
                        $(m.modal).addClass('hidden').attr('aria-hidden', 'true');
                        m._open = false;
                        m._previouslyFocussedElement.focus();
                        if (m._config.onClose) {
                            m._config.onClose();
                        }
                        $('body').removeClass('cc-blocked');
                        document.removeEventListener('keydown', this._onKeyDown);
                    });
                    $('button[data-id="request-size-title"]').attr({
                        'aria-required': 'true',
                        'aria-describedby': 'form-selecttitle-error'
                    });

                    var $grecaptcha = $(overlay + ' .js-captcha-form.lazyloading');
                    if ($grecaptcha.length) {
                        document.body.dispatchEvent(new CustomEvent('grecaptcha-load', {detail: $grecaptcha}));
                    }
                }
            });
        });
    },
    submitRequestSize: function () {
        $(document).on('click', '.js-requestsize-button', function () {
            const readyToSubmit = $.Deferred();
            var url = $('.js-requestsize-button').data('action');
            var form = $($('.js-form-control-requestsize')[0]);
            var size = form.find('.js-requestsize-size :selected').text().trim();
            var productID = $('.js-product-id').val().trim() + $('.js-color-selected').val().trim();
            var label = productID + ' - ' + size;
            form.find('[name=ecomSize]').val(size);
            var checkHoneyPot = $('.contact_me_if_spam').val();
            var isSpam = checkHoneyPot.length > 0;

            if (navigationCountry === 'CN') {
                // initialize tencent captcha
                var $tencentCaptchaEl = $('.js-tencent-captcha-container', form);
                TencentCaptcha.initialize($tencentCaptchaEl, readyToSubmit);
            } else {
                readyToSubmit.resolve();
            }

            if (!isSpam) {
                readyToSubmit.done(function() {
                    form.spinner().start();
                    $.ajax({
                        url: url,
                        method: 'POST',
                        data: form.serialize(),
                        success: function (data) {
                            form.spinner().stop();
                            $('.js-form-control-requestsize').fadeOut();
                            $('.js-success-page-requestSize').fadeIn();
                            uploadSuccesPage($('.js-success-page-requestSize'), data);
                            // analytics
                            if (data.response.success === true) {
                                dataLayer.push({
                                    event: 'requestSize',
                                    eventCategory: 'Request Size',
                                    eventAction: 'submit_ok',
                                    eventLabel: label
                                });
                            } else {
                                dataLayer.push({
                                    event: 'requestSize',
                                    eventCategory: 'Request Size',
                                    eventAction: 'submit_fail',
                                    eventLabel: label
                                });
                            }
                            // END
                        },
                        error: function (data) {
                            // analytics
                            dataLayer.push({
                                event: 'requestSize',
                                eventCategory: 'Request Size',
                                eventAction: 'submit_fail',
                                eventLabel: label
                            });
                            // END
                            form.spinner().stop();
                            $('.js-form-control-requestsize').fadeOut();
                            $('.js-success-page-requestSize').fadeIn();
                            uploadSuccesPage($('.js-success-page-requestSize'), data.responseJSON);
                        }
                    });
                });
            }
        });
    },
    // sizes help chart
    sizeChart: function () {
        $('body').on('click', '.js-open-size-chart', function (e) {
            e.preventDefault();
            var buttonPressed = $(this);
            var url = buttonPressed.data('href');
            var buttonID = this.id;
            $('.cc-size-chart-overlay-container').css('content-visibility', 'visible');
            if (buttonID === 'size-chart-stiky' && !window.isMobile) {
                $('#js-open-from-sticky').val(true);
            } else {
                $('#js-open-from-sticky').val(false);
            }

            if (window.isMobile) {
                var $prodSizeChart = $('#js-size-chart-content-mobile');
                var modalTarget = buttonPressed.data('target-mobile');
            } else {
                var $prodSizeChart = $('#js-size-chart-content');
                var modalTarget = buttonPressed.data('target');
            }
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'text',
                    success: function (data) {
                        $prodSizeChart.html(data);
                        if (window.isMobile) {
                            $('.js-open-choice').toArray().forEach(closeModal);
                        }
                        e.stopPropagation();

                        var modal = new Modal(modalTarget, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                        modal.open();
                    }
                });
            } else {
                var modal = new Modal(modalTarget, { onShow: openSizeChartModal, onClose: closeSizeChartModal });
                modal.open();
            }
        });
    },

    // share button
    share: function () {
        $(document).on('click', '.cc-pdp .js-newpdp-openshare', function (e) {
            $('.cc-pdp__actions-desktop .cc-share-overlay').fadeIn();
            $(this).addClass('cc-share-background-overlay');
            accessFocus.focusOnFirstElement('.cc-share-overlay');
            accessFocus.focuseOnModal('.cc-share-overlay', '.cc-share-button-share', '.cc-share-overlay');
            e.stopPropagation();
        });

        $(document).on('click', '.cc-pdp .js-newpdp-openshare-mobile', function (e) {
            $('.js-whatsapp-link').attr('href', function() { this.href = this.href.replace('https://wa.me/?text=', 'whatsapp://send?text='); });
            $('body').css('overflow', 'hidden');
            $('.cc-mobile-content-share').css('display', 'block');
            $('.cc-sticky-add-to-cart').css('display', 'none');

            var heightSocialHead = 75;
            var top;
            var headerHeight = $('header').height();
            var heightPage = $(window).height();
            if (heightPage < 550) {
                top = headerHeight + heightSocialHead;
            } else {
                var heightSocialListLink = $('.cc-mobile-content-share .cc-social-link-mobile').height();
                var heightSocialListUl = $('.cc-mobile-content-share .cc-social-list-ul').height();
                var heightSocialList = heightSocialListUl + heightSocialListLink;
                top = heightPage - heightSocialList - heightSocialHead;
            }
            $('.cc-mobile-content-share').css('top', top);
            $(this).addClass('cc-share-background-overlay');
            e.stopPropagation();
            liveChatDisable();
        });

        // close share section mobile
        $(document).on('click', '.cc-pdp .cc-mobile-content-share .cc-mobile-close-share-button', function (e) {
            $('.cc-mobile-content-share').css('display', 'none');
            $('.cc-sticky-add-to-cart').css('display', 'block');
            $('.cc-pdp .js-newpdp-openshare-mobile').removeClass('cc-share-background-overlay');
            var copyLink = $('.js-link-label').data('copy');
            $('.js-link-label').find('.js-social-text').text(copyLink);
            $('body').css('overflow', 'visible');
            e.stopPropagation();
            liveChatEnable();
        });

        // close share section desktop
        $(document).on('click', '.cc-pdp .cc-close-overlay-share-button', function (e) {
            $(this).closest('.cc-share-overlay').fadeOut();
            $('.cc-pdp .js-newpdp-openshare').removeClass('cc-share-background-overlay');
            var copyLink = $('.js-link-label').data('copy');
            $('.js-link-label').find('.js-social-text').text(copyLink);
            e.stopPropagation();
            // Accesibility, move focus back on Share btn
            $(".cc-open-shareSection").focus();
        });
    },

    fixStickybarHidingOnClick: function () {
        // fix stickybar hiding when clicking on color or size selector
        $('.js-sticky-add-to-cart').on('click', function (e) {
            var now = Date.now().toString();
            $(this).attr('data-recent-click', now);
            let $sticky = $('.cc-sticky-add-to-cart').not('.js-sticky-add-to-cart-look');
            var visibleCheckElement = document.getElementsByClassName('visible-check');
            let isAddToCartVisible = false;
            if (visibleCheckElement.length > 0) {
                isAddToCartVisible = visibleCheckElement && visibleCheckElement[0].getBoundingClientRect().bottom > 0;
            }
            let isFooterVisible = footerElement.getBoundingClientRect().top < viewportHeight;
            let stickyCanAppear;
            let stickyIsOpen = $sticky.hasClass('cc-open');
            stickyCanAppear = !isAddToCartVisible && !isFooterVisible;
            setTimeout(() => {
                if ($(this).attr('data-recent-click') === now) {
                    $(this).attr('data-recent-click', '');
                }
                // check if the stickybar's position is still valid
                if (stickyCanAppear && !stickyIsOpen) {
                    // close all open subwindows
                    let $modals = $('.cc-sticky-add-to-cart').find('.js-sticky-choice').toArray();
                    $modals.forEach((el) => {
                        $(el).removeClass('cc-open');
                        $($(el).data('target')).removeClass('cc-open');
                    });
                    // hide stickybar
                    let $sticky = $('.cc-sticky-add-to-cart').not('.js-sticky-add-to-cart-look');
                    $sticky.removeClass('cc-open').addClass('cc-close');
                }
            }, 1000);
        });
    },

    // go to detail
    analyticsGoToDetail: function () {
        var pid = $(document).find('.cc-pdp').data('pid');
        $(document).on('click', '.js-goto-detail', function () {
            dataLayer.push({
                event: 'custom_event',
                eventCategory: 'More detail Anchor',
                eventAction: 'pdp',
                eventLabel: pid
            });
        });
    }
};
